var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19V17.75C13 15.679 11.081 14 8.714 14H7.286C4.919 14 3 15.679 3 17.75V19M15.286 14H16.714C19.081 14 21 15.679 21 17.75V19M15 5.17001C15.4524 5.01061 15.9364 4.96201 16.4115 5.02829C16.8866 5.09457 17.3388 5.27381 17.7303 5.55095C18.1218 5.8281 18.4412 6.19508 18.6616 6.62113C18.8819 7.04717 18.997 7.51984 18.997 7.99951C18.997 8.47918 18.8819 8.95186 18.6616 9.3779C18.4412 9.80394 18.1218 10.1709 17.7303 10.4481C17.3388 10.7252 16.8866 10.9044 16.4115 10.9707C15.9364 11.037 15.4524 10.9884 15 10.829M11 8.00001C11 8.79566 10.6839 9.55872 10.1213 10.1213C9.55871 10.6839 8.79565 11 8 11C7.20435 11 6.44129 10.6839 5.87868 10.1213C5.31607 9.55872 5 8.79566 5 8.00001C5 7.20436 5.31607 6.4413 5.87868 5.87869C6.44129 5.31608 7.20435 5.00001 8 5.00001C8.79565 5.00001 9.55871 5.31608 10.1213 5.87869C10.6839 6.4413 11 7.20436 11 8.00001Z",
    stroke: "",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.8af35f890e013104263fdf44220718d9.svg";
export { ForwardRef as ReactComponent };